export const canCustom = type => type === 'text' || type === 'button';
